module.exports = "<div class=\"tooltip {{ placement }}\"\n     [style.top]=\"top + 'px'\"\n     [style.left]=\"left + 'px'\"\n     [class.in]=\"isIn\"\n     [class.fade]=\"isFade\"\n     role=\"tooltip\">\n    <div class=\"tooltip-inner\" style=\"background-color: white; color: black; border-radius: 0px; border: 1px solid black; box-shadow: 0 2px 2px 0px; padding: 10px;\">\n        <ng-content></ng-content>\n        {{ content }}\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/tooltip-content/tooltip-content.component.html
// module id = ./src/app/tooltip-content/tooltip-content.component.html
// module chunks = main